import joi from 'joi';
import { parseDateJsonDef } from './parse.date.json.def';

export const dateDefault = joi.alternatives(
	joi.string().isoDate().example('2023-01-12T05:14:02.887Z'),
	parseDateJsonDef
);
